import { useState } from "react"

export default function useAgendaUIState() {
  const [showNewModal, setShowNewModal] = useState(false)
  const [saving, setSaving] = useState(false)

  const [selectedHeldEvent, setSelectedHeldEvent] = useState(null)
  const [selectedAppointment, setSelectedAppointment] = useState(null)
  const [selectedAppointmentTreatmentId, setSelectedAppointmentTreatmentId] = useState("")

  const [checkingIn, setCheckingIn] = useState(false)
  const [registeringTreatment, setRegisteringTreatment] = useState(false)

  const [dragAlternatives, setDragAlternatives] = useState([])
  const [dragConflictInfo, setDragConflictInfo] = useState(null)
  const [loadingDragAlternatives, setLoadingDragAlternatives] = useState(false)

  const [creatingPatient, setCreatingPatient] = useState(false)

  const [financialSummary, setFinancialSummary] = useState(null)
  const [loadingFinancialSummary, setLoadingFinancialSummary] = useState(false)
  const [registeringPayment, setRegisteringPayment] = useState(false)
  const [creatingReceivable, setCreatingReceivable] = useState(false)

  const [patientSnapshot, setPatientSnapshot] = useState(null)
  const [loadingPatientSnapshot, setLoadingPatientSnapshot] = useState(false)
  const [patientAlerts, setPatientAlerts] = useState([])
  const [loadingPatientAlerts, setLoadingPatientAlerts] = useState(false)

  const [patientWorkspaceOpen, setPatientWorkspaceOpen] = useState(false)
  const [patientWorkspaceTab, setPatientWorkspaceTab] = useState("expediente")
  const [patientOdontogram, setPatientOdontogram] = useState(null)
  const [loadingPatientOdontogram, setLoadingPatientOdontogram] = useState(false)

  const [treatmentPlans, setTreatmentPlans] = useState([])
  const [loadingTreatmentPlans, setLoadingTreatmentPlans] = useState(false)
  const [showTreatmentPlanModal, setShowTreatmentPlanModal] = useState(false)

  const [viewMode, setViewMode] = useState("OPERATIVE")
  const [uiComplexity, setUiComplexity] = useState("SIMPLE")
  const [uiComplexityAuto, setUiComplexityAuto] = useState(true)

  const [creatingOdontogramEntry, setCreatingOdontogramEntry] = useState(false)

  const [odontogramForm, setOdontogramForm] = useState({
    tooth: "",
    surface: "ALL",
    condition: "Caries",
    status: "ACTIVE"
  })

  const [treatmentOdontogramForm, setTreatmentOdontogramForm] = useState({
    tooth: null,
    surface: "ALL",
    condition: "Caries",
    status: "COMPLETED"
  })

  const [paymentForm, setPaymentForm] = useState({
    amount: "",
    method: "CASH",
    notes: ""
  })

  const [receivableForm, setReceivableForm] = useState({
    totalAmount: ""
  })

  const [quickPatient, setQuickPatient] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: ""
  })

  const [newAppt, setNewAppt] = useState({
    patientId: "",
    treatmentId: "",
    doctorId: "",
    chairId: "",
    start: "",
    duration: 30,
    treatmentPlanItemId: "",
    planTitle: ""
  })

  return {
    showNewModal,
    setShowNewModal,
    saving,
    setSaving,

    selectedHeldEvent,
    setSelectedHeldEvent,
    selectedAppointment,
    setSelectedAppointment,
    selectedAppointmentTreatmentId,
    setSelectedAppointmentTreatmentId,

    checkingIn,
    setCheckingIn,
    registeringTreatment,
    setRegisteringTreatment,

    dragAlternatives,
    setDragAlternatives,
    dragConflictInfo,
    setDragConflictInfo,
    loadingDragAlternatives,
    setLoadingDragAlternatives,

    creatingPatient,
    setCreatingPatient,

    financialSummary,
    setFinancialSummary,
    loadingFinancialSummary,
    setLoadingFinancialSummary,
    registeringPayment,
    setRegisteringPayment,
    creatingReceivable,
    setCreatingReceivable,

    patientSnapshot,
    setPatientSnapshot,
    loadingPatientSnapshot,
    setLoadingPatientSnapshot,
    patientAlerts,
    setPatientAlerts,
    loadingPatientAlerts,
    setLoadingPatientAlerts,

    patientWorkspaceOpen,
    setPatientWorkspaceOpen,
    patientWorkspaceTab,
    setPatientWorkspaceTab,
    patientOdontogram,
    setPatientOdontogram,
    loadingPatientOdontogram,
    setLoadingPatientOdontogram,

    treatmentPlans,
    setTreatmentPlans,
    loadingTreatmentPlans,
    setLoadingTreatmentPlans,
    showTreatmentPlanModal,
    setShowTreatmentPlanModal,

    viewMode,
    setViewMode,
    uiComplexity,
    setUiComplexity,
    uiComplexityAuto,
    setUiComplexityAuto,

    creatingOdontogramEntry,
    setCreatingOdontogramEntry,

    odontogramForm,
    setOdontogramForm,
    treatmentOdontogramForm,
    setTreatmentOdontogramForm,

    paymentForm,
    setPaymentForm,
    receivableForm,
    setReceivableForm,

    quickPatient,
    setQuickPatient,
    newAppt,
    setNewAppt
  }
}